<template>
    <div class="w-100">
        <label v-if="field.field_type !== 'Link to Object'" class="col-form-label"><strong>{{field.name}}</strong></label>
        <form-element class="my-2" :table="table" :field="field" :document="document"></form-element>
    </div>
</template>

<script>

    export default {
        name: 'FormFieldContainer',
        props: ['field', 'document', 'table', 'required']
    }
</script>

<style>

</style>
